module.exports = __webpack_public_path__ + "static/media/si-LK.eb7839f1.md";